import React from "react";
import { __ } from "@wordpress/i18n";

const ContentHeader = ({title,description}) => {
	return (
		<div className="header-section border-bottom">
			<h1 className="header-title primary-text-color bold">{__(title,"access-control")}</h1>
			<p className="header-description primary-text-color regular" style={{opacity: 1}}	>{__(description,"access-control")}</p>
		</div>
	);
};

export default ContentHeader;
